export const AssignmentFieldsLabel: Record<
  string,
  { title: string; type?: string }
> = {
  id: { title: 'Id', type: 'string' },
  assignment_title: { title: 'Title', type: 'string' },
  objective: { title: 'Objective', type: 'string' },
  cta: { title: 'Call to Action', type: 'string' },
  call_to_action: { title: 'Call to Action', type: 'array' },
  article_type: { title: 'Type', type: 'string' },
  word_count: { title: 'Word count', type: 'string' },
  asst_name: { title: 'Assignment Title', type: 'string' },
  amount: { title: 'Amount', type: 'currency' },
  due_date: { title: 'Due Date', type: 'string' },
  client_deadline: { title: 'Assignment Deadline', type: 'date' },
  status_code_id: { title: 'Status Code Id', type: 'string' },
  status_code: { title: 'Status Code', type: 'string' },
  primary_keywords: { title: 'Primary Keywords', type: 'multiple' },
  other_keywords: { title: 'Other Keywords', type: 'multiple' },
  backlinks: { title: 'Backlinks', type: 'link' },
  other_information: { title: 'Other information', type: 'string' },
  flow_of_newsletter: { title: 'Flow of Newsletter', type: 'string' },
  product_url: { title: 'Product URL', type: 'link' },
  translation_link: { title: 'Translation Link', type: 'link' },
  quotes: { title: 'Quotes', type: 'string' },
  boiler_plate: { title: 'Boilerplate', type: 'string' },
  reference_links: { title: 'Reference Links', type: 'links' },
  is_outline_structure: {
    title: 'Do you have a outline or structure for the white paper in mind?',
    type: 'boolean'
  },
  outline_structure: { title: 'Outline Structure', type: 'string' },
  client_feedback: { title: 'Client Feedback', type: 'string' },
  design_content: { title: 'Design Content', type: 'string' },
  design_logo_purpose: { title: 'Design Logo Purpose', type: 'string' },
  design_blog_content: { title: 'Design Blog Content', type: 'string' },
  design_number_of_images_needed: {
    title: 'Design No. of images needed',
    type: 'string'
  },
  design_name_on_the_logo: { title: 'Design Name on the logo', type: 'string' },
  design_brand_description: {
    title: 'Design Brand Description',
    type: 'string'
  },
  design_logo_tagline_visibility: {
    title: 'Design Logo Tagline Visibility',
    type: 'string'
  },
  design_logo_tagline: { title: 'Design Logo Tagline', type: 'string' },
  design_infographic_description: {
    title: 'Design Description',
    type: 'string'
  },
  design_adapts_languages: {
    title: 'Adapts Languages',
    type: 'multiple'
  },
  reference_files: { title: 'Reference Files', type: 'file' },
  current_writer_deadline: { title: 'Creator Deadline', type: 'date' },
  current_writer_pay: { title: 'Creator Pay', type: 'currency' },
  current_editor_pay: { title: 'Editor Pay', type: 'currency' },
  design_gif_description: { title: 'Design Description', type: 'string' },
  description: { title: 'Description', type: 'string' },
  design_sizes: { title: 'Design Sizes', type: 'multiple' },
  design_frames_needed: { title: 'Design Frames needed', type: 'string' },
  design_cta: { title: 'Design CTA', type: 'multiple' },
  design_layout_sizes: { title: 'Design Layout Sizes', type: 'string' },
  design_number_of_pages: { title: 'Design No. of pages', type: 'string' },
  design_other_instructions: {
    title: 'Design Instructions - Other',
    type: 'string'
  },
  design_other_references: {
    title: 'Design References - Other',
    type: 'string'
  },
  design_presentation_editable: {
    title: 'Design Presentation Editable',
    type: 'string'
  },
  design_presentation_need_transitions: {
    title: 'Design Presentation Need Transitions',
    type: 'string'
  },
  reference_files_design_content: {
    title: 'Reference files for Design Content',
    type: 'comment-box'
  },
  design_style_to_follow: { title: 'Design Style to follow', type: 'string' },
  design_visual_tone: { title: 'Design Visual Tone', type: 'multiBlockSelect' },
  design_can_use_stock_images: { title: 'Design Stock Images', type: 'string' },
  design_logo_contents: { title: 'Design Logo Content', type: 'string' },
  design_project_purpose: { title: 'Design Project Purpose', type: 'string' },
  design_project_audience: { title: 'Design Project Audience', type: 'string' },
  design_show_trademark_on_logo: {
    title: 'Design Show Trademark',
    type: 'string'
  },
  design_show_brand_logo: { title: 'Design Show Brand Logo', type: 'string' },
  design_presentation_transitions: {
    title: 'Design Presentation Transitions',
    type: 'string'
  },
  design_other_information: {
    title: 'Design Other Information',
    type: 'string'
  },
  design_publish_through: { title: 'Design Publish Through', type: 'string' },
  design_file_formats_needed: {
    title: 'Design File formats needed',
    type: 'multiple'
  },
  design_open_files_needed: {
    title: 'Design Open Files needed',
    type: 'string'
  },
  design_open_file_formats_needed: {
    title: 'Design Open File Formats',
    type: 'string'
  },
  design_text_density: { title: 'Design Text density', type: 'string' },
  design_things_to_cover: { title: 'Design Things to cover', type: 'array' },
  design_brand_guidelines_present: {
    title: 'Design Brand Guidelines',
    type: 'string'
  },
  design_client_color_preference: {
    title: 'Design Color Preference',
    type: 'multiBlockSelect'
  },
  design_client_font_preference: {
    title: 'Design Client Font preference',
    type: 'string'
  },
  design_client_custom_colors: {
    title: 'Design Client custom colors',
    type: 'customColour'
  },
  design_references_logo_files: {
    title: 'Design References: Logo Files',
    type: 'string'
  },
  design_references_brand_style_guide: {
    title: 'Design References: Brand Style Guide',
    type: 'string'
  },
  things_to_avoid: {
    title: 'Things To avoid',
    type: 'string'
  },
  other_instructions: { title: 'Other Instructions', type: 'string' },
  writer_pov: { title: 'Writer POV', type: 'string' },
  article_flow: { title: 'Article Flow', type: 'string' },
  goals: { title: 'Project Goals', type: 'multiple' },
  tones: { title: 'Tone of Voice', type: 'multiple' },
  audience: { title: 'Audience', type: 'string' },
  meta_data: { title: 'Meta Data', type: 'boolean' },
  genre: { title: 'Genre', type: 'string' },
  experience_level: { title: 'Experience Level', type: 'string' },
  headline_purposes: { title: 'Headline Purposes', type: 'multiple' },
  platforms: { title: 'Platforms', type: 'multiple' },
  submission_files: { title: 'Submission Files Updated', type: 'file' },
  tags: { title: 'Tags', type: 'multiple' },
  current_editor_deadline: { title: 'Editor Deadline', type: 'date' },
  sub_vertical: { title: 'Purpose', type: 'string' },
  meta_description: { title: 'Meta Description', type: 'string' },
  assignment_description: { title: 'Assignment Description', type: 'string' },
  language_id: { title: 'Language', type: 'multiBlockSelect' },
  project_goals: { title: 'Project Goals', type: 'multiple' },
  tone_of_voice: { title: 'Tone of voice', type: 'multiple' },
  project_need: { title: 'Project Need', type: 'array' },
  other_links: { title: 'Loom URLs', type: 'loomUrls' },
  is_quotes: {
    title: 'Is there a quote we could use in the press release?',
    type: 'boolean'
  },
  is_headline_purposes: {
    title: 'Should we include a catchy headline for the press release?',
    type: 'boolean'
  },
  design_adapts_variant: {
    title: 'Design Adapts Variant',
    type: 'string'
  },
  other_vertical: { title: 'Vertical', type: 'string' },
  submission_content: { title: 'Submission Text', type: 'string' },
  sub_genre: { title: 'Sub Genre', type: 'string' },
  publishing_platform: { title: 'Publishing Platform', type: 'string' },
  audience_bio: { title: 'Audience Bio', type: 'string' },
  project_scope: { title: 'Project scope', type: 'string' },
  content_website_page: {
    title: 'Which page of the website do you need content for?',
    type: 'string'
  },
  website_page_intent: {
    title: 'What is the webpage intended to do?',
    type: 'string'
  },
  website_link: {
    title:
      'Share the website wireframe/ staging website (for new websites) or existing website link',
    type: 'string'
  },
  outline_flow: {
    title: 'Specify content outline/flow',
    type: 'string'
  },
  seo_guidelines: {
    title: 'Any SEO guidelines you want to share',
    type: 'string'
  },
  about_brand_themes: {
    title:
      'Tell us about your brand and the themes you want highlighted in the content',
    type: 'string'
  },
  literature: {
    title: 'Share literature on your products, value propositions',
    type: 'string'
  },
  meta_data_description: {
    title: 'Do you need a meta description?',
    type: 'string'
  },
  research_references: { title: 'Research References', type: 'string' },
  content_focus: {
    title: 'What is the focus of the white paper?',
    type: 'string'
  },
  content_structure: {
    title:
      'What should be the structure or outline of this white paper? If you do not have a structure in mind, tell us the key components / themes you want to include.',
    type: 'string'
  },
  thought_leader: {
    title: 'Whom do you want to establish as a thought leader?',
    type: 'string'
  },
  thought_leader_social_handle: {
    title:
      'Add the LinkedIn, website or other social media handle(s) or link(s) of the thought leader',
    type: 'string'
  },
  thought_leader_pov: {
    title: "What is the thought leader's point-of-view on this topic?",
    type: 'string'
  },
  pov_preferred_way: {
    title: 'Choose your preferred way of describing point of view',
    type: 'string'
  },
  thought_leader_writing_style: {
    title: 'Choose the writing style of the thought leader',
    type: 'string'
  },
  preserve_original_formatting: {
    title: 'Would you like to preserve the original formatting of content?',
    type: 'boolean'
  },
  translation_type_id: {
    title: 'What type of translation are you looking at for the project?',
    type: 'number'
  },
  translation_word_usage_id: {
    title:
      'Are you looking for direct colloquial Translation or Pure Translation for this project?',
    type: 'number'
  },
  adapts_main_design: {
    title: 'Upload the original image and the open file of the main design',
    type: 'string'
  },
  design_adapts_types_needed: {
    title: 'What type of Adapt(s) do you need',
    type: 'array'
  },
  approx_design_frames_needed: {
    title: 'Approx. number of frames needed per carousel',
    type: 'string'
  },
  ecommerce_platforms: {
    title: 'Select the platform',
    type: 'array'
  },
  subject_matter: {
    title: 'Select the subject matter:',
    type: 'string'
  },
  about_content_piece: {
    title: 'What is this content piece about?',
    type: 'string'
  },
  sub_vertical_id: {
    title: 'Sub Vertical',
    type: 'string'
  },
  visuals: {
    title: 'Visuals',
    type: 'string'
  },
  translation_languages_target_id: {
    title: 'Translation Languages Target',
    type: 'string'
  },
  translation_type: {
    title: 'Are you looking for Language Localisation or Pure Translation?',
    type: 'string'
  },
  document_template_id: {
    title: 'Template',
    type: 'string'
  },
  translation_type_name: {
    title: 'Are you looking for Language Localisation or Pure Translation?',
    type: 'string'
  },
  reference_websites: {
    title:
      'Share at least 2 reference websites (tonality and word choice inspiration OR competitor wesites)',
    type: 'string'
  },
  design_adapts_main_design: {
    title: 'Adapts main design',
    type: 'string'
  },
  publishing_objective: {
    title: 'What is the goal or key objective of publishing this white paper?',
    type: 'multiple'
  },
  short_form_copy: {
    title: 'Short Form Copy',
    type: 'string'
  },
  sow_id: {
    title: 'SOW ID',
    type: 'string'
  },
  deal_id: {
    title: 'Deal ID',
    type: 'string'
  }
}
